import {RelativeDateRange} from './relative-date-range';
import {DateRange} from './date-range';
import {FullLengthDateRange} from './full-length-date-range';
import {InsightsTimePickerDateRange} from './insights-time-picker-date-range';
import {PropertyFilterDateRange} from './property-filter-date-range';
import {ImpactDateRange} from './impact-date-range';
import {DisplayContext} from './types';

export const DATE_RANGE_TYPES: {[key in DisplayContext]: typeof DateRange} = {
  [DisplayContext.RelativeRange]: RelativeDateRange,
  [DisplayContext.Default]: DateRange,
  [DisplayContext.FullLength]: FullLengthDateRange,
  [DisplayContext.ImpactTimePicker]: ImpactDateRange,
  [DisplayContext.InsightsTimePicker]: InsightsTimePickerDateRange,
  [DisplayContext.PropertyFilter]: PropertyFilterDateRange,
};

export class DateRangeFactory {
  public static createDateRange(
    attributes: Partial<DateRange>,
    {displayContext}: {displayContext: DisplayContext},
  ): DateRange {
    const DateRangeClass = DATE_RANGE_TYPES[displayContext];
    return new DateRangeClass(attributes);
  }
}
